import React from 'react';
import { ExternalLink } from 'lucide-react';

const NetworkLinks: React.FC = () => {
  const networkSites = [
    { name: 'RadonLab HQ', url: 'https://radonlab.ca', description: 'Canada\'s Radon Science Authority' },
    { name: 'Radon Inspectors', url: 'https://radoninspectors.ca', description: 'Book professional testing' },
    { name: 'Radon Detectors', url: 'https://radondetectors.ca', description: 'Professional detection equipment' },
    { name: 'Radon Kits', url: 'https://radonkits.ca', description: 'DIY testing solutions' },
    { name: 'Radon Ventilation', url: 'https://radonventilation.ca', description: 'Mitigation systems' },
    { name: 'Radon Monitoring', url: 'https://radonmonitoring.ca', description: 'Continuous monitoring' },
    { name: 'What Is Radon', url: 'https://whatisradon.ca', description: 'Educational resources' },
    { name: 'Radon Risk Calculator', url: 'https://radonrisk.ca', description: 'Assess your risk' },
    { name: 'Canada Radon Levels', url: 'https://radonlevels.ca', description: 'National data' }
  ];

  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">RadonLab Network</h2>
          <p className="text-gray-600">Canada's Unified Radon Safety System</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {networkSites.map((site, index) => (
            <a
              key={index}
              href={site.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-200 group"
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-gray-900 group-hover:text-red-600 transition-colors">
                    {site.name}
                  </h3>
                  <p className="text-sm text-gray-600">{site.description}</p>
                </div>
                <ExternalLink className="h-4 w-4 text-gray-400 group-hover:text-red-600 transition-colors" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NetworkLinks;